import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SliderRating from "../../SliderReating/SliderReating";
import HowItWorks from "../../HowItWorks/HowItWorks";
import OurServices from "../../OurServices/OurServices";
import Button from "react-bootstrap/Button";
// import HiddenDangers from "../../CarpetCleaning/HiddenDangers/HiddenDangers";
import Laundrybaba from "../../LaundryEXPRESS/Laundrybaba";
import CleanServicesLaundry from "../../CleanServicesLaundry/CleanServicesLaundry";
//  Correct imports for Swiper v10+
import { Navigation } from "swiper/modules";
import { Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import ServiceCards from "../../Offerlaundry/OffersPromotions/Services Cards/ServicesCards"
import "./HeroSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
// Replace these with your images
// const slides = [
//   { src: "/images/diva-laundry4-1.webp", textLeft: true },
//   { src: "/images/diva-laundry3.webp", textLeft: false },
//   { src: "/images/diva-laundry2.webp", textLeft: true },
// ];


const slides = [
  { src: "https://darling-bublanina-051337.netlify.app/images/a_cinematic_eye_level_view_of_a_fresh_n_clean_laundry_shop_storefront_at_dusk._the_blue_branding_is_illuminated_featuring_the_logo_and_text_from_data_image_image_3_in_english_and_arabic._large_glass_windows_show_a_.png", textLeft: true },
  { src: "https://darling-bublanina-051337.netlify.app/images/a_cinematic_eye_level_view_of_a_fresh_n_clean_laundry_shop_storefront_at_dusk._the_blue_branding_is_illuminated_featuring_the_logo_and_text_from_data_image_image_3_in_english_and_arabic._large_glass_windows_show_a_.png", textLeft: false },
  { src: "https://darling-bublanina-051337.netlify.app/images/a_cinematic_eye_level_view_of_a_fresh_n_clean_laundry_shop_storefront_at_dusk._the_blue_branding_is_illuminated_featuring_the_logo_and_text_from_data_image_image_3_in_english_and_arabic._large_glass_windows_show_a_.png", textLeft: true },
];
const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div className="mt-5">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]} // modules fixed
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className={`hero-slide ${slide.textLeft ? "text-left" : "text-right"}`}
              style={{ backgroundImage: `url(${slide.src})` }}
            >

              <div className="hero-content mt-5">

                <svg className="desktop-svg" viewBox="0 0 1200 300">
                  <br />
                  <text x="50%" y="30%" textAnchor="middle">
                    Personalised
                  </text>
                  <text x="50%" y="60%" textAnchor="middle">
                    Premium Laundry Services
                  </text>
                  <text x="50%" y="90%" textAnchor="middle">
                    Professionally Trusted
                  </text>
                </svg>

                {/* Normal Text (Mobile only) */}
                <h1 className="mobile-text">
                  Personalised <br />
                  Premium Laundry Services <br />
                  Professionally Trusted
                </h1>
                <p style={{ fontSize: "14px" }}>
                  we pick-up and deliver within 24 hours-fresh,clean &
                  convenient-exacty what you need !
                </p>
                <div className="hero-buttons">
                  <div className="hero-buttons">
                    <a
                      style={{ textDecoration: "none" }}
                      href="https://api.whatsapp.com/send?phone=971545718455"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pickup-btn"
                    >
                      📱 Schedule a Pickup
                    </a>

                    <a
                      style={{ textDecoration: "none", color: "white", fontWeight: "bold" }}

                      href="tel:+971545718455"
                      className="toll-number"
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      📞 Customer Care Number: 054 571 8455
                    </a>
                    {/* <a
                      style={{ textDecoration: "none", color: "white", fontWeight: "bold" }}
                      href="tel:+9715457184XXX"
                      className="toll-number"
                    >
                      📞 Customer Care  Number 0545718455
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>


      <div data-aos="fade-up">
        <SliderRating />
      </div>

      {/* <div data-aos="fade-up">
        <Laundrybaba />
      </div> */}
      <div data-aos="fade-up">
        <HowItWorks />
      </div>

      <div data-aos="fade-up">
        <OurServices />
      </div>

      <div data-aos="fade-up">
        <CleanServicesLaundry />
      </div>

      <ServiceCards />


    </div>
  );
};

export default HeroSection;
